const rankingItems = [
  { rank: 1, title: '长安十二时辰2', type: '电视剧', heat: '9.8', change: 'up', tag: 'NEW' },
  { rank: 2, title: '流浪地球3', type: '电影', heat: '9.7', change: 'up', tag: 'HOT' },
  { rank: 3, title: '破冰行动2', type: '电视剧', heat: '9.5', change: 'same', tag: '' },
  { rank: 4, title: '深海2', type: '动画电影', heat: '9.3', change: 'up', tag: '' },
  { rank: 5, title: '漫长的季节', type: '电视剧', heat: '9.1', change: 'down', tag: '' },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            热播榜单
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            本周最受欢迎的影视内容排行
          </p>
        </div>

        <div className="bg-background-50 border border-background-200/70 rounded-2xl overflow-hidden">
          {rankingItems.map((item, i) => (
            <div
              key={i}
              className={`flex items-center gap-4 px-5 md:px-6 py-4 ${
                i < rankingItems.length - 1 ? 'border-b border-background-200/60' : ''
              } hover:bg-background-100 transition-colors cursor-pointer group`}
            >
              <div className={`flex-shrink-0 w-8 h-8 md:w-9 md:h-9 rounded-lg flex items-center justify-center text-sm font-bold ${
                item.rank === 1
                  ? 'bg-accent-500 text-white'
                  : item.rank === 2
                  ? 'bg-secondary-400 text-white'
                  : item.rank === 3
                  ? 'bg-primary-400 text-white'
                  : 'bg-background-200 text-foreground-500'
              }`}>
                {item.rank}
              </div>

              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2">
                  <h3 className="text-sm md:text-base font-semibold text-foreground-950 group-hover:text-primary-500 transition-colors truncate">
                    {item.title}
                  </h3>
                  {item.tag && (
                    <span className={`flex-shrink-0 px-1.5 py-0.5 text-[10px] font-bold rounded ${
                      item.tag === 'NEW'
                        ? 'bg-primary-100 text-primary-600'
                        : 'bg-accent-100 text-accent-600'
                    }`}>
                      {item.tag}
                    </span>
                  )}
                </div>
                <span className="text-xs text-foreground-400">{item.type}</span>
              </div>

              <div className="flex items-center gap-3 flex-shrink-0">
                <i className={`text-sm ${
                  item.change === 'up'
                    ? 'ri-arrow-up-line text-green-500'
                    : item.change === 'down'
                    ? 'ri-arrow-down-line text-red-400'
                    : 'ri-subtract-line text-foreground-400'
                }`}></i>
                <span className="text-sm font-bold text-accent-500 min-w-[3rem] text-right">
                  {item.heat}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}